import { Injectable } from "@angular/core";
import { ApiResultError, CheckUtils } from "..";
import { ApiEndPoint } from "./api-end-point";
var AuthenticationEndPoints = /** @class */ (function () {
    function AuthenticationEndPoints(apiEndPoint) {
        this.apiEndPoint = apiEndPoint;
    }
    AuthenticationEndPoints.prototype.signUp = function (authenticationSignUpApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(authenticationSignUpApiData))
                return;
            _this.apiEndPoint.post("customerportal/register", authenticationSignUpApiData).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.signInWithCookie = function (authenticationSignInCookieApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post("customerportal/login", authenticationSignInCookieApiData).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.signIn = function (signInVo) {
        var _this = this;
        if (signInVo.code != null && signInVo.code !== "" && signInVo.password != null && signInVo.password !== "") {
            signInVo.token = AuthenticationEndPoints._authenticationToken;
        }
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post("customerportal/login", signInVo).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    if (res.verified) {
                        AuthenticationEndPoints._authenticationToken = undefined;
                    }
                    else {
                        AuthenticationEndPoints._authenticationToken = res.authenticationToken;
                    }
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.signOut = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(token))
                return;
            _this.apiEndPoint.post("customerportal/logout", { token: token }).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.resetPassword = function (authenticationResetPasswordApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(authenticationResetPasswordApiData))
                return;
            _this.apiEndPoint.post("customerportal/resetPasswordRequest", authenticationResetPasswordApiData).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.validateRegistration = function (uuid, authenticationValidateConfirmationApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.areEmpty(uuid, authenticationValidateConfirmationApiData))
                return;
            _this.apiEndPoint.post("registration/validateConfirmation", authenticationValidateConfirmationApiData, false, false, "uuid=" + uuid).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.processConfirmation = function (uuid, authenticationProcessConfirmationApiData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.areEmpty(uuid, authenticationProcessConfirmationApiData))
                return;
            _this.apiEndPoint.post("registration/processConfirmation", authenticationProcessConfirmationApiData, false, false, "uuid=" + uuid).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.validatePassword = function (password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post("user/validatePassword", password)
                .subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.prototype.loginUserDescriptions = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(token))
                return;
            _this.apiEndPoint.get("customerportal/loginUserDescriptions", false, true, "token=" + token).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    Object.defineProperty(AuthenticationEndPoints.prototype, "connectHandler", {
        set: function (handler) {
            this.apiEndPoint.connectHandler = handler;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationEndPoints.prototype.is2FAEnabled = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post("customerportal/is2FAEnabled", { email: email })
                .subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ;
    AuthenticationEndPoints.prototype.getAuthByCode = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post("login/getLoginByCode", { email: email })
                .subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    ;
    AuthenticationEndPoints.prototype.sendCodeByLoginName = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post("customerportal/sendCodeByLoginName", data)
                .subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    AuthenticationEndPoints.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AuthenticationEndPoints.ctorParameters = function () { return [
        { type: ApiEndPoint, },
    ]; };
    return AuthenticationEndPoints;
}());
export { AuthenticationEndPoints };
//# sourceMappingURL=authentication-end-points.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/endpoints/authentication-end-points.js
// module id = 247
// module chunks = 14